import { createRoot } from "react-dom/client";
import { App } from "./app/App.js";

createRoot(document.getElementById("root")!).render(<App />);
